import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import orderService from "../services/new-order-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import moment from "moment";
import { deselectAllRows, selectAllRows, selectRow, deselectRow } from "ka-table/actionCreators";
import { kaPropsUtils } from 'ka-table/utils';

const tablePropsInit = {
  columns: [
    {
      key: 'selection-cell',
      isFilterable: false,
    },
    { key: "facCode", title: "Facilty Code" },
    { key: "patId", title: "Patient ID" },
    { key: "patName", title: "Patient Name" },
    { key: "rx", title: "RX" },
    { key: "drug", title: "Drug" },
    { key: "expandedSig", title: "Sig" },
    { key: "qtyRemaining1", title: "Quantity Remaining", style: { display: "none" } },
    { key: "qtyRemaining", title: "Quantity Remaining" },
    { key: "refillDueDate", title: "Refill Due Date" },
    { key: "earliestRefillDate", title: "Earliest Due Date" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "rxfId",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 50,
    position: PagingPosition.Bottom,
  },
};

const RefillsDue = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [selectedFilter, _] = useState("ALL");
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [refillList, setRefillList] = useState([]);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await orderService.getRefillsDue(selectedFilter);
      setLoading(false);
      setRefillList(resp);
      dispatch(updateData(resp));
    }
  };

  const CustomCellEarliestRefillDate = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          {rowData?.earliestRefillDate ? moment.utc(rowData?.earliestRefillDate).format("MM-DD-YYYY") : ""}
        </span>
      </div>
    );
  };
  const CustomCellRefillDate = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          {rowData?.refillDueDate ? moment.utc(rowData?.refillDueDate).format("MM-DD-YYYY") : ""}
        </span>
      </div>
    );
  };
  const onSubmit = async () => {
    try {
      setLoading(true);
      const selectedRefills = kaPropsUtils.getSelectedData(tableProps);
      if (selectedRefills?.length === 0) {
        const { hide } = cogoToast.error(
          "Please select at least one record",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
        return;
      }
      const selectedFillIds = selectedRefills.reduce((accumulator, currentValue) => {
        accumulator.push(currentValue.rxfId);
        return accumulator
      },
        [],
      );
      await orderService.submitRefillsDue(selectedFillIds);
      getRefillsDueDetails(selectedFilter);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  }
  const getRefillsDueDetails = async (filter) => {
    try {
      setLoading(true);
      dispatch(deselectAllRows());
      setRefillList([]);
      let resp = await orderService.getRefillsDue(filter);
      setAllselect(false);
      setRefillList(resp);
      dispatch(updateData(resp));
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }

  const SelectionHeader = (props) => {
    return (
      <input
        type='checkbox'
        checked={allselect}
        onChange={(event) => {
          if (event.currentTarget.checked) {
            dispatch(selectAllRows());
            setAllselect(true);
          } else {
            dispatch(deselectAllRows());
            setAllselect(false);
          }
        }}
      />
    );
  };
  const [allselect, setAllselect] = useState(false);

  const SelectionCell = ({ rowKeyValue, isSelectedRow, selectedRows }) => {
    return (
      <input
        type='checkbox'
        checked={isSelectedRow}
        onChange={(event) => {
          if (event.currentTarget.checked) {
            dispatch(selectRow(rowKeyValue));
          } else {
            dispatch(deselectRow(rowKeyValue));
          }
        }}
      />
    );
  };

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"
          }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>

      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">REFILLS DUE</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 mb-2 h-10 mb--3 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className={`absolute w-4 h-4  right-5 bottom-5 `}
              ></img>
            </span>
          </div>
        </div>
        <div className="p-2 text-xs usersList gridList overflow-x-auto">
          <Table
            className="table-fixed"
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "selection-cell":
                      return <SelectionCell {...props} />
                    case "earliestRefillDate":
                      return <CustomCellEarliestRefillDate {...props} />;
                    case "refillDueDate":
                      return <CustomCellRefillDate {...props} />;

                  }
                },
              },
              headCell: {
                content: (props) => {
                  if (props.column.key === 'selection-cell') {
                    return <SelectionHeader {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch}
          />
        </div>
        <div className="mx-3">
          {refillList?.length !== 0 && <button
            disabled={loading}
            className={
              loading
                ? "opacity-50 cursor-not-allowed pointer-events-none text-rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
                : "rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
            }
            onClick={() => onSubmit()}
          >
            SUBMIT
          </button>
          }
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(RefillsDue)
);
